import { h } from "@stencil/core";
import { renderShowcaseProperties, updateShowcase } from "../utils";
const state = {};
const formRefs = {
    "form-switch-1": undefined,
    "form-switch-2": undefined,
    "form-switch-3": undefined
};
const formValues = {
    "switch-1": "",
    "switch-2": "",
    "switch-3": ""
};
const handleValueInput = (formId, switchId) => () => {
    formValues[switchId] = Object.fromEntries(new FormData(formRefs[formId]))[switchId];
    // TODO: Until we support external slots in the ch-flexible-layout-render,
    // this is a hack to update the render of the widget and thus re-render the
    // combo-box updating the displayed items
    updateShowcase();
};
const render = () => (h("div", { class: "checkbox-test-main-wrapper" }, h("fieldset", { class: "fieldset-test" }, h("legend", { class: "heading-4 field-legend-test" }, "No label"), h("form", { id: "form-switch-1", ref: el => (formRefs["form-switch-1"] = el) }, h("ch-switch", { name: "switch-1", accessibleName: state.accessibleName, class: "switch", checkedValue: state.checkedValue, unCheckedValue: state.unCheckedValue, checkedCaption: state.checkedCaption, unCheckedCaption: state.unCheckedCaption, disabled: state.disabled, value: state.value, onInput: handleValueInput("form-switch-1", "switch-1") })), "Form value: ", formValues["switch-1"]), h("fieldset", { class: "fieldset-test" }, h("legend", { class: "heading-4 field-legend-test" }, "Label with HTML for"), h("form", { id: "form-switch-2", ref: el => (formRefs["form-switch-2"] = el) }, h("label", { class: "label", htmlFor: "switch-2" }, "Label for switch 2"), h("ch-switch", { id: "switch-2", name: "switch-2", accessibleName: state.accessibleName, class: "switch", checkedValue: state.checkedValue, unCheckedValue: state.unCheckedValue, checkedCaption: state.checkedCaption, unCheckedCaption: state.unCheckedCaption, disabled: state.disabled, value: state.value, onInput: handleValueInput("form-switch-2", "switch-2") })), "Form value: ", formValues["switch-2"]), h("fieldset", { class: "fieldset-test" }, h("legend", { class: "heading-4 field-legend-test" }, "Component inside label"), h("form", { id: "form-switch-3", ref: el => (formRefs["form-switch-3"] = el) }, h("label", { class: "label", htmlFor: "switch-3" }, "Label for switch 3", h("ch-switch", { id: "switch-3", name: "switch-3", accessibleName: state.accessibleName, class: "switch", checkedValue: state.checkedValue, unCheckedValue: state.unCheckedValue, checkedCaption: state.checkedCaption, unCheckedCaption: state.unCheckedCaption, disabled: state.disabled, value: state.value, onInput: handleValueInput("form-switch-3", "switch-3") }))), "Form value: ", formValues["switch-3"])));
const showcaseRenderProperties = [
    {
        caption: "Properties",
        properties: [
            {
                id: "accessibleName",
                caption: "Accessible Name",
                value: undefined,
                type: "string"
            },
            {
                id: "checkedValue",
                caption: "Checked Value",
                value: "true",
                type: "string"
            },
            {
                id: "unCheckedValue",
                caption: "Unchecked Value",
                value: undefined,
                type: "string"
            },
            {
                id: "checkedCaption",
                caption: "Checked Caption",
                value: "Checked caption",
                type: "string"
            },
            {
                id: "unCheckedCaption",
                caption: "Unchecked Caption",
                value: "Unchecked caption",
                type: "string"
            },
            {
                id: "disabled",
                caption: "Disabled",
                value: false,
                type: "boolean"
            }
        ]
    }
];
const showcasePropertiesInfo = [
    { name: "accessibleName", defaultValue: undefined, type: "string" },
    {
        name: "class",
        fixed: true,
        value: "switch",
        type: "string"
    },
    { name: "checkedCaption", defaultValue: undefined, type: "string" },
    { name: "checkedValue", defaultValue: undefined, type: "string" },
    { name: "disabled", defaultValue: false, type: "boolean" },
    { name: "name", defaultValue: undefined, type: "string" },
    { name: "unCheckedCaption", defaultValue: undefined, type: "string" },
    { name: "unCheckedValue", defaultValue: undefined, type: "string" },
    { name: "value", defaultValue: undefined, type: "string" },
    { name: "input", fixed: true, value: "handleInput", type: "event" }
];
export const switchShowcaseStory = {
    properties: showcaseRenderProperties,
    markupWithoutUIModel: {
        react: () => `<ChSwitch${renderShowcaseProperties(state, "react", showcasePropertiesInfo)}
      ></ChSwitch>`,
        stencil: () => `<ch-switch${renderShowcaseProperties(state, "stencil", showcasePropertiesInfo)}
        ></ch-switch>`
    },
    render: render,
    state: state
};
